/**
 * useNotifications Hook
 * Manages notification state with WebSocket integration
 */
import { useCallback } from 'react';
import { trpc } from '../utils/trpc';
export function useNotifications({ enabled, filter = 'all' }) {
    const listQuery = trpc.notifications.list.useQuery({ filter, limit: 100, offset: 0 }, { enabled, refetchOnWindowFocus: false });
    const syncMutation = trpc.notifications.sync.useMutation({
        onSuccess: () => {
            listQuery.refetch();
        },
    });
    const handleWebSocketMessage = useCallback((message) => {
        switch (message.type) {
            case 'notification:new':
            case 'notification:update':
            case 'sync:complete':
                // Refetch the list when new data arrives
                listQuery.refetch();
                break;
            case 'error':
                console.error('WebSocket error:', message.message);
                break;
        }
    }, [listQuery]);
    return {
        notifications: listQuery.data?.notifications ?? [],
        total: listQuery.data?.total ?? 0,
        hasMore: listQuery.data?.hasMore ?? false,
        isLoading: listQuery.isLoading,
        isRefetching: listQuery.isRefetching,
        isSyncing: syncMutation.isPending,
        syncError: syncMutation.error,
        sync: () => syncMutation.mutate(),
        refetch: () => listQuery.refetch(),
        handleWebSocketMessage,
    };
}
